import React from "react";
import { flowGradeColour } from "../constants/flowPresentation";
import FlowMarkSlider from "./FlowMarkSlider";
import { clampMark } from "../utils/markBounds";

export default function FlowMarkInput({ label, weight, max, value, onChange, ariaLabel, pointsPerMark, impactTarget = "subject total" }) {
  const id = `mark-${(ariaLabel || label).toLowerCase().replace(/[^a-z0-9]+/g, "-")}`;
  const boundedValue = clampMark(value, max);
  const fraction = boundedValue !== "" && max > 0 ? Number(boundedValue) / max : 0;
  const update = (event) => {
    onChange(clampMark(event.target.value, max));
  };
  return (
    <div className="mark">
      <div className="mark-heading">
        <label htmlFor={id} className="mark-name">{label}</label>
        {weight && <span id={`${id}-weight`} className="mark-weight"><span className="sr-only">Weight: </span>{weight}</span>}
      </div>
      {Number.isFinite(pointsPerMark) && <span id={`${id}-impact`} className="mark-impact" aria-label={`One extra mark adds ${Number(pointsPerMark.toFixed(2))} percentage points to your ${impactTarget}.`}>+1 mark = <strong>+{Number(pointsPerMark.toFixed(2))}</strong> / 100</span>}
      <div className="mark-control" style={{ "--mark-fill": fraction, "--mark-colour": flowGradeColour(boundedValue === "" ? null : fraction * 7) }}>
        <input id={id} type="number" inputMode="decimal" min={0} max={max} step={1} value={boundedValue} placeholder="--" aria-label={ariaLabel || `${label} marks`} aria-describedby={[weight && `${id}-weight`, Number.isFinite(pointsPerMark) && `${id}-impact`].filter(Boolean).join(" ") || undefined} onChange={update} />
        <span>/ {max}</span>
        <FlowMarkSlider value={boundedValue} max={max} onChange={onChange} label={ariaLabel || `${label} marks`} />
      </div>
    </div>
  );
}
